import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class MissingService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;


  getMissingList(fromDate: Date, toDate: Date, wholesalerId: number, branchId: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "dataentry/view-missing?fromDate=" + fromDate + "&toDate=" + toDate + "&wholesalerId=" + wholesalerId + "&branchId=" + branchId).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getDownloadURL(fromDate: Date, toDate: Date, wholesalerId: number, branchId: any): any {
    const authToken = sessionStorage.getItem("authToken");
    return this.url + "dataentry/view-missing/download?fromDate=" + fromDate + "&toDate=" + toDate + "&wholesalerId=" + wholesalerId + "&branchId=" + branchId + "&token=" + authToken;
  }

  downloadMissing(fromDate: Date, toDate: Date, wholesalerId: number, branchId: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.download(this.url + "dataentry/view-missing/download?fromDate=" + fromDate + "&toDate=" + toDate + "&wholesalerId=" + wholesalerId + "&branchId=" + branchId).subscribe((result: any) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  emailData(fromDate: Date, toDate: Date, wholesalerId: number, branchId: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "dataentry/view-missing/email?fromDate=" + fromDate + "&toDate=" + toDate + "&wholesalerId=" + wholesalerId + "&branchId=" + branchId).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }


}